module.exports = __webpack_public_path__ + "img/agently_logo.d8a55ab7.png";